<template>
    <div class="accounting_data_wrap">
        <StockData :menuList="menuList" @changeActive="changeActive" @changeItemActive="changeItemActive">
             <!-- 右侧财会数据 -->
            <div class="accounting_data_content stock_detail" slot="stock_detail">
                <div class="flex-center exchange_name">
                    <div>{{accountingData.accountingName}}</div>
                    <div class="ml10" v-if="accountingData.accountingInfo">
                        <el-tooltip  placement="right-start" effect="light">
                            <div slot="content" class="notice_text">{{accountingData.accountingInfo}}</div>
                            <i class="el-icon-question mouse-hover"></i>
                        </el-tooltip>
                    </div>
                </div>
                <div class="filter_wrap">
                   <div class="quotation_info">行情数据：<span>{{accountingData.description}}</span></div>
                   <div  class="data_card">
                       <div class="top_tips">选择年份</div>
                       <div class="flex-center filter_item">
                           <div class="filter_title">选择目标年份：</div>
                           <el-date-picker
                             v-model="selectYear"
                             align="right"
                             type="year"
                             placeholder="选择日期"
                             value-format="yyyy"
                             :picker-options="pickerOptions">
                           </el-date-picker>
                       </div>
                       <div v-if="!['每股指标','盈利能力','成长能力','营运能力','偿债及资本机构','现金流量'].includes(accountingData.accountingName)">
                            <div class="top_tips">选择报告期</div>
                            <div class="radio_wrap">
                                <el-radio-group v-model="reportDate">
                                    <el-radio v-for="item in reportDateList" :key="item.id" :label="item.id">{{item.name}}</el-radio>
                                </el-radio-group>
                            </div>
                       </div>

                       <div class="top_tips">选择股票</div>
                       <div class="select_wrap"  v-if="!['每股指标','盈利能力','成长能力','营运能力','偿债及资本机构','现金流量'].includes(accountingData.accountingName)">
                            <el-radio-group v-model="selectStock">
                                <el-radio :label="0">
                                    选择所有股票
                                </el-radio>
                                <el-radio :label="1">
                                    <div class="flex-center mutil_choice">
                                        <div>选择多支股票：</div>
                                        <el-select @focus="selectStock = 1" v-model="selectOptionsArr"  multiple suffix-icon="el-icon-search" placeholder="股票代码 / 股票名称" reserve-keyword :remote-method="querySearch" :loading="loading" filterable remote >
                                            <el-option  v-for="item in optionsArr"  :key="item.code"  :label="item.value"  :value="item.value"></el-option>
                                        </el-select>
                                    </div>
                                </el-radio>
                            </el-radio-group>
                       </div>
                       <div class='select_wrap flex-center' v-else>
                           <div>选择单只股票：</div>
                           <div>
                               <el-autocomplete :trigger-on-focus='false' placeholder='股票代码 / 股票名称'
                                                :fetch-suggestions='queryStock' v-model='symbol'></el-autocomplete>
                           </div>

                       </div>
                       <div class='but_btn'>
                           <div class='donload_btn' @click='queryTheData'>查询数据</div>
                           <div></div>
                       </div>
                   </div>
                    <DataPreview
                        v-if='whetherToShowAPreview'
                        ref='dataPreview'
                        :down-load-data='downloadData'
                        api-url='/ms_resource/finance/preview'
                        :queryParameters='queryParameters'
                    ></DataPreview>
                </div>
            </div>
        </StockData>
        <el-dialog :visible.sync="dialogVisible" width="60%">
            <div class="dialog_title">数据预览结果</div>
            <div>
                <el-table  :data="tableArr" :cell-style="{textAlign:'center',padding:'5px 0px'}"  stripe  :header-cell-style="$core.table_header"></el-table>
            </div>
            <div class="flex-around mat10">
                <el-button type="primary">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { financeMenu, getStocksearch } from '../../utils/api';
import DataPreview from '@/components/common/DataPreview';

export default {
    components: {
        DataPreview
    },
    data() {
        return {
            tableArr: [],
            dialogVisible: false,
            optionsArr: [],
            selectOptionsArr: [],
            symbol: '',
            loading: false,
            stokeType: '财务数据',
            isShowReport: '',
                menuList:[],
                activeIndex:1,
                pickerOptions:{
                    disabledDate(data){
                        return data && data.valueOf() >= new Date()
                    }
                },
                selectYear:'',
                selectStock:0,
                reportDate:'3-31',
                reportDateList:[{
                    id:'3-31',
                    name:'3月31日'
                },{
                    id:'6-30',
                    name:'6月30日'
                },{
                    id:'9-30',
                    name: '9月30日'
                }, {
                    id: '12-31',
                    name: '12月31日'
                }],
            accountingData: {
                currentItem: '',
                accountingName: '',
                description: '',
                accountingInfo: ''
            },
            queryParameters: {},
            whetherToShowAPreview: true
        }
        },
        created(){
            this.getMenuList()
            // this.menuList = JSON.parse('[{"title":"金融期权","subMenuList":[{"id":4,"title":"上海证券交易所"},{"id":5,"title":"深圳证券交易所"},{"id":6,"title":"中国金融期货交易所"}]},{"title":"商品期权","subMenuList":[{"id":9,"title":"上海期货交易所"},{"id":10,"title":"大连商品交易所"},{"id":11,"title":"郑州商品交易所"}]}]')
            // this.menuList = JSON.parse('[{"title":"年报季报","subMenuList":[{"id":4,"title":"业绩报表"},{"id":5,"title":"资产负债表"},{"id":6,"title":"利润表"},{"id":21,"title":"现金流量表"}]},{"title":"财务指标","subMenuList":[{"id":9,"title":"每股指标"},{"id":10,"title":"盈利能力"},{"id":13,"title":"成长能力"},{"id":19,"title":"营运能力"},{"id":18,"title":"偿债及资本结构"},{"id":17,"title":"现金流量"}]}]')
        },
        methods:{
            // 单只股票模糊查询
            async queryStock(query, cb){
                await getStocksearch({ keyword: query,menuId:3 }).then(res => {
                    cb(res.data);
                })
                .catch(err => {});
            },
            // 模糊查询
            querySearch(query) {
                this.loading = true;
                getStocksearch({ keyword: query, menuId: 3 })
                    .then(res => {
                        this.optionsArr = res.data;
                        this.loading = false;
                    })
                    .catch(err => {
                    });
            },
            //查询数据
            queryTheData() {
                this.whetherToShowAPreview = true;
                if (!this.selectYear) return this.$message.warning('请选择年份');
                if (this.selectStock !== 0 && this.selectOptionsArr.length === 0) return this.$message.warning('请选择股票');
                this.queryParameters = {
                    date: this.selectYear + '-' + this.reportDate,
                    codes: +this.selectStock === 0 ? [] : this.selectOptionsArr.map(item => {
                        let index = item.indexOf(' ');
                        return item.substring(0, index);
                    }).join(','),
                    id: this.activeItemIndex,
                    symbol: this.symbol
                };
                setTimeout(() => {
                    this.$refs.dataPreview.queryTheData();
                });
            },
            // 下载数据
            downloadData() {
                if (!this.selectYear) return this.$message.error('请选择年份');
                let params = {
                    codes: this.selectStock == 0 ? [] : this.selectOptionsArr.map(item => {
                        let index = item.indexOf(' ');
                        return item.substring(0, index);
                    }),
                    date: this.selectYear + '-' + this.reportDate,
                    id: this.activeItemIndex,
                    keyword: '',
                    page: 1,
                    preview: false,
                    size: 8,
                    symbol: this.symbol
                };
                let url = this.$core.setObjToUrlParams(this.$config.BASE_URL+'/finance/data',params)
                const loading = this.$loading({
                    lock:true,
                    text:'拼命加载中..',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                })
                this.$core.downloadFileData('GET',url).then(res => {loading.close()}).catch(err => {loading.close()})
            },
            // 获取期权数据目录
            getMenuList(){
                financeMenu().then(res => {
                    this.menuList = res.data
                    this.activeIndex = res.data[0].id
                    this.activeItemIndex = res.data[0].subMenuList[0].id
                    this.accountingData.accountingName = res.data[0].subMenuList[0].title
                    this.accountingData.description = res.data[0].subMenuList[0].description
                }).catch(err => {})
            },

            // el-submenu改变时获取index
            changeActive(index,item){
                this.activeIndex = item.id;
                this.whetherToShowAPreview = false;
            },

            clearCache(){
                this.selectYear = '',
                this.selectStock = 0,
                this.reportDate = '3-31',
                this.selectOptionsArr = [],
                this.optionsArr = [],
                this.symbol = ''
            },

             // el-menu-item改变时操作
             changeItemActive(index,item){
                this.clearCache()
                this.accountingData.accountingName = item.title
                item.remarks ? (this.accountingData.accountingInfo = item.remarks) : (this.accountingData.accountingInfo = '')
                this.accountingData.description = item.description
                this.activeItemIndex = item.id
             }
        },
    }
</script>
<style lang='scss' scoped>

.dialog_title{
    color: #271B63;
    font-weight: bold;
    font-size: 24px;
    padding-left: 15px;
    border-left: 0.5rem solid #002D72;
}

.mutil_choice{
    /deep/.el-input{
        width: 500px;
    }
}
.select_wrap{
    /deep/.el-radio{
        display: flex;
        align-items: center;
        margin-bottom: 20px;
    }
}
.radio_wrap{
    margin: 15px 0px 25px 0px;
}
.top_tips{
    padding-left: 20px;
    font-size: 20px;
    position: relative;
    left: -30px;
}
.download-button{
    margin: 20px auto 0px 90px ;
}
.filter_wrap{
    .filter_button{
        margin-top: 30px;
        >div{
            padding: 10px 40px;
            color: #666666;
            background: white;
            margin-right: 15px;
            border-radius: 4px;
            font-size: 18px;
            &:hover{
                @extend .active_button;
                cursor: pointer;
                opacity: 0.8;
            }
        }
        .active_button{
            color: white;
            background: #002D72;
        }
    }

}
.data_card{
    box-sizing: border-box;
    padding: 40px 120px;
    background: white;
    font-size: 18px;
    margin-top: 10px;
    border-radius: 10px 10px 0px 0px;
    .filter_item{
        margin-bottom: 30px;
        .filter_title{
            color: #666666;
        }
    }
    /deep/.el-checkbox{
        width: 150px;
        margin-bottom: 15px;
    }
    /deep/.el-radio__label{
        font-size: 18px;
    }
}
.quotation_info{
    font-size: 18px;
    font-weight: bold;
    color: #271B63;
    margin: 15px 0px;
    span{
        font-weight: 100;
    }
}
.exchange_name{
    font-weight: bold;
    font-size: 24px;
    color: #271B63;
    i{
        font-size: 20px;
    }
}
.notice_text {
    max-width: 800px;
}
.accounting_data_content{
    width: 90%;
}
</style>
